import * as React from 'react';
import CreditsRowMobile from '../CreditsRowMobile';
import EmptyCredits from '../EmptyCredits';
import CreditModel from 'src/model/credit.model';
import CreditsVoidModal from '../CreditsVoidModal';

interface ICreditsTableMobileProps {
  credits: CreditModel[];
  selectedCredit: CreditModel;
  handleCreditDetails: (credit: CreditModel) => void;
}

interface ICreditsTableMobileState {
  paymentIdToVoid: number;
  showVoidModal: boolean;
}

class CreditsTableMobile extends React.Component<
  ICreditsTableMobileProps,
  ICreditsTableMobileState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      paymentIdToVoid: null,
      showVoidModal: false
    };
  }

  private voidCredit = (paymentId: number) => {
    this.setState({ paymentIdToVoid: paymentId, showVoidModal: true });
  };

  private handleCloseVoidModal = () => {
    this.setState({ showVoidModal: false });
  };

  private handleCreditDetails = (e: any, credit: CreditModel) => {
    e.preventDefault();
    this.props.handleCreditDetails(credit);
  };

  private handleChangeCheckbox = (credit: any) => {
    if (!credit.taker) {
      this.voidCredit(credit.id);
    }
  };

  public render() {
    return (
      <div className="rp-echeck-table-mobile">
        {this.props.credits.length === 0 && <EmptyCredits />}
        {this.props.credits.map(credit => (
          <CreditsRowMobile
            key={credit.paymentId}
            credit={credit}
            onShowDetails={this.handleCreditDetails}
            onChangeCheckbox={this.handleChangeCheckbox}
          />
        ))}
        {this.state.showVoidModal && this.state.paymentIdToVoid && (
          <CreditsVoidModal
            handleCloseModal={this.handleCloseVoidModal}
            paymentId={this.state.paymentIdToVoid}
          />
        )}
      </div>
    );
  }
}

export default CreditsTableMobile;
